// Effectively disabling the multi-value "chips" feature of react-select
export const MultiValue = props => props.children;